import { Box } from "@chakra-ui/react";
import { motion } from "framer-motion";
import React from "react";
import { SidebarType, useSidebarStore } from "../../../hooks/sidebar.hooks";
import useEscape from "../../../hooks/useEscape";
import Button from "../../Core/Button/Button";
import ConsultantsSidebar, { ConsultantSidebarProps } from "./ConsultantsSidebar";
import AssignedConsultantsSidebar, {
	AssignedConsultantsSidebarProps,
} from "./AssignedConsultantsSidebar";

interface Props {
	type: SidebarType;
	sidebarProps?: ConsultantSidebarProps | AssignedConsultantsSidebarProps;
}

const Sidebar: React.FC<Props> = ({ type, sidebarProps }) => {
	const state = useSidebarStore();

	let InnerSidebar = null;

	if (type === "MATCHING_CONSULTANTS" && sidebarProps) {
		InnerSidebar = <ConsultantsSidebar {...(sidebarProps as ConsultantSidebarProps)} />;
	}

	if (type === "ASSIGNED_CONSULTANTS" && sidebarProps) {
		InnerSidebar = (
			<AssignedConsultantsSidebar {...(sidebarProps as AssignedConsultantsSidebarProps)} />
		);
	}

	if (!InnerSidebar) {
		return null;
	}

	useEscape({
		onEscape: state.closeSidebar,
	});

	return (
		<motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.1 }}>
			<Box
				bg={"white"}
				width={{ base: "450px", xl: "650px", "2xl": "700px" }}
				height={"100vh"}
				position="absolute"
				right={0}
				top={0}
				zIndex={101}
				borderLeftStyle="solid"
				borderLeftColor="gray.400"
				borderLeftWidth={1}
			>
				<Box pos={"absolute"} right="1.5" top="1.5" zIndex={102}>
					<Button onClick={state.closeSidebar} backgroundColor="transparent" icon="cross" />
				</Box>

				{InnerSidebar}
			</Box>
		</motion.div>
	);
};

export default Sidebar;
